/* eslint eqeqeq: 0 */
import { Record } from "immutable";
import { moment } from "../../utils";

const WidgetStatItemRecord = new Record({
  date: undefined,
  shows: 0,
  vshows: 0,
  clicks: 0,
  ctr: 0,
  vctr: 0,
  revenue: 0,
  rpm: 0,
  vrpm: 0,
  vshows_percent: 0,
});

export default class WidgetStatItem extends WidgetStatItemRecord {
  isWeekEnd() {
    const day = moment(this.date).day();

    if (day == 0 || day == 6) {
      return true;
    }

    return false;
  }
}
